import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { authContext } from '@staffedupusa/shared-components';
import { FC, useContext, useEffect, useState } from 'react';

import { white } from '@styles/colors';
import { medium } from '@styles/fontWeights';
import { ShareIcon } from '../../../../vectors/index';
import { socialShareOptions } from './constants';
import CloseIcon from '@mui/icons-material/Close';
import { useGetMetrics } from '@features/enterpriseMetrics/hooks/useGetSavedMessages';


type PostHiringLinkModalProps = {
  isOpen: boolean;
  selectedCompanyId?: string | number;
  handleClose: () => void;
};

const getButtonStyles = (mainColor: string) => ({
  boxShadow: 'none',
  backgroundColor: mainColor,
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: mainColor,
  fontWeight: medium,
  '&:hover': {
    backgroundColor: 'transparent',
    borderColor: mainColor,
    color: mainColor,
    svg: {
      color: mainColor,
    },
  },
});

const PostHiringLinkModal: FC<PostHiringLinkModalProps> = ({
  isOpen,
  selectedCompanyId,
  handleClose,
}) => {
  const { authData } = useContext(authContext);
  const [selectedComany, seSelectedCompany] = useState(null)
  const { metricsData, isLoadingMetrics } = useGetMetrics({
    enterprise_id: authData?.user?.enterprise?.id,
    selectedCompanyId: 'ALL',
  });

  useEffect(() => {
    if (selectedCompanyId && metricsData) {
      const selectCompany = metricsData?.companies?.find(item => item.company_id == selectedCompanyId)
      seSelectedCompany(selectCompany ?? null)
    }
  }, [metricsData, selectedCompanyId])


  const handleShare = (url: string) => {
    const companyUrl = encodeURIComponent(
      // @ts-ignore
      // enterprise updated
      `${import.meta.env.VITE_MARKETING_SITE_URL}${authData.user?.company ? authData.user?.company.s_slug : authData.user?.enterprise && selectedComany ? selectedComany.s_slug : ''}?src=social`,
    );
    window.open(`${url}${companyUrl}`, '_blank');
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <br />
        <ShareIcon />
        <br />
        <Typography variant="h4">Post Your Hiring Link</Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ marginBottom: 1 }}>
          {socialShareOptions.map(({ title, url, color, Icon }) => (
            <Button
              key={title}
              variant="contained"
              sx={getButtonStyles(color)}
              startIcon={<Icon sx={{ color: white }} />}
              onClick={() => handleShare(url)}
            >
              {title}
            </Button>
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default PostHiringLinkModal;
